/**
 * User Profile Service
 * Handles API requests for user profile management
 */
import apiClient from './apiClient';

/**
 * Get the current user profile information
 * @returns {Promise<Object>} User profile data
 */
const getUserProfile = async () => {
  try {
    const response = await apiClient.get('/api/supplier/user-profile');
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

/**
 * Update the user profile information
 * @param {Object} profileData Object containing profile data to update
 * @param {string} profileData.displayUserName The display username
 * @param {string} profileData.phoneNumber The phone number
 * @param {string} profileData.email The email address
 * @param {string} [profileData.about] The about description
 * @returns {Promise<Object>} Updated user profile data
 */
const updateUserProfile = async (profileData) => {
  try {
    // Make sure we have the required fields
    if (!profileData.displayUserName || !profileData.email) {
      throw new Error('Missing required profile update data');
    }
    
    const response = await apiClient.put('/api/supplier/user-profile', {
      displayUserName: profileData.displayUserName,
      phoneNumber: profileData.phoneNumber,
      email: profileData.email,
      about: profileData.about
    });
    
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

export default {
  getUserProfile,
  updateUserProfile
}; 